export default "__VITE_ASSET__VQbHrysz__"